import React from 'react';

import { LinkList } from '@eika/link-list';

import { MonetaryAmount } from '@generated-types';
import useText from '@hooks/use-text';
import { prettyMonetary } from '@utils/text-format-utils';

interface SpendingLimitCategoryLinkProps {
    description: string;
    limit: MonetaryAmount | undefined;
    onClick: () => void;
}

export const SpendingLimitCategoryLink = ({ description, limit, onClick }: SpendingLimitCategoryLinkProps) => {
    const text = useText();

    return (
        <LinkList.ItemAsButton
            onClick={onClick}
            labels={
                limit ? (
                    <span className="spending-limit-category-link__value">{prettyMonetary(limit)}</span>
                ) : (
                    <span className="spending-limit-category-link__value__empty">
                        {text.spendingLimitsLabelAddLimit}
                    </span>
                )
            }
        >
            <span className="spending-limit-category-link__description">{description}</span>
        </LinkList.ItemAsButton>
    );
};
